export class Classificacao {
    idClassificacao: any;
    dsClassificacao: any;
    flAtivo: any;
    codClassificao: any;

    constructor() {
        this.idClassificacao = "";
        this.dsClassificacao = "";
        this.codClassificao = "";
        this.flAtivo = "";
    }
}


// WEBPACK FOOTER //
// ./src/models/Classificacao.ts